import React, { useState } from "react";
import Navbar from "react-bootstrap/Navbar";
import { Nav, Offcanvas } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import "./navbar.scss";
const Header = () => {
  const { hash } = useLocation();
  const isActive = (iHash) => hash === iHash;
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleClick = (e) => {
    setShow(false);
    e.preventDefault();
    setTimeout(() => {
      window.location.href = "#home";
    }, 1000);
  };
  const handleClick1 = (e) => {
    setShow(false);
    e.preventDefault();
    setTimeout(() => {
      window.location.href = "#about";
    }, 1000);
  };
  const handleClick2 = (e) => {
    setShow(false);
    e.preventDefault();
    setTimeout(() => {
      window.location.href = "#how";
    }, 1000);
  };
  const handleClick3 = (e) => {
    setShow(false);
    e.preventDefault();
    setTimeout(() => {
      window.location.href = "#why";
    }, 1000);
  };
  const handleClick4 = (e) => {
    setShow(false);
    e.preventDefault();
    setTimeout(() => {
      window.location.href = "#luck";
    }, 1000);
  };
  const handleClick5 = (e) => {
    setShow(false);
    e.preventDefault();
    setTimeout(() => {
      window.location.href = "#usecases";
    }, 1000);
  };

  return (
    <>
      <section className="main-navbar">
        <div className="custom-container">
          <Navbar expand="lg">
            <Navbar.Brand href="/">
              <img src="/logo.svg" alt="logo" className="nav-logo" />
            </Navbar.Brand>
            <div className="navbar-toggler" onClick={handleShow}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M3 12H21"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M3 18H21"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M3 6H21"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <Navbar.Collapse id="navbarScroll">
              <Nav>
                <HashLink
                  to="#home"
                  class="nav-link"
                  style={
                    isActive("#home")
                      ? {
                          color: "#B078FF",
                        }
                      : {}
                  }
                >
                  Home
                </HashLink>
                <HashLink
                  to="#about"
                  class="nav-link"
                  style={
                    isActive("#about")
                      ? {
                          color: "#B078FF",
                        }
                      : {}
                  }
                >
                  About
                </HashLink>
                <HashLink
                  to="#how"
                  class="nav-link"
                  style={
                    isActive("#how")
                      ? {
                          color: "#B078FF",
                        }
                      : {}
                  }
                >
                  How it Works?
                </HashLink>
                <HashLink
                  to="#why"
                  class="nav-link"
                  style={
                    isActive("#why")
                      ? {
                          color: "#B078FF",
                        }
                      : {}
                  }
                >
                  Why it Matters?
                </HashLink>
                <HashLink
                  to="#luck"
                  class="nav-link"
                  style={
                    isActive("#luck")
                      ? {
                          color: "#B078FF",
                        }
                      : {}
                  }
                >
                  $LUCK
                </HashLink>
                <HashLink
                  to="#usecases"
                  class="nav-link"
                  style={
                    isActive("#usecases")
                      ? {
                          color: "#B078FF",
                        }
                      : {}
                  }
                >
                  Use Cases
                </HashLink>
              </Nav>
              <a href="/lightpaper.pdf" target="_blank" className="greybtn">read LIGHTPAPER</a>
            </Navbar.Collapse>
          </Navbar>
        </div>
      </section>

      <Offcanvas show={show} onHide={handleClose} className="mainoffcan">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <img src="/logo.svg" alt="logo" className="nav-logo" />
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <HashLink
            to="#home"
            class="nav-link"
            onClick={handleClick}
            style={
              isActive("#home")
                ? {
                    color: "#B078FF",
                    backgroundColor: "#271B39",
                  }
                : {}
            }
          >
            Home
          </HashLink>
          <HashLink
            to="#about"
            class="nav-link"
            onClick={handleClick1}
            style={
              isActive("#about")
                ? {
                    color: "#B078FF",
                    backgroundColor: "#271B39",
                  }
                : {}
            }
          >
            About
          </HashLink>
          <HashLink
            to="#how"
            class="nav-link"
            onClick={handleClick2}
            style={
              isActive("#how")
                ? {
                    color: "#B078FF",
                    backgroundColor: "#271B39",
                  }
                : {}
            }
          >
            How it Works?
          </HashLink>
          <HashLink
            to="#why"
            onClick={handleClick3}
            class="nav-link"
            style={
              isActive("#why")
                ? {
                    color: "#B078FF",
                    backgroundColor: "#271B39",
                  }
                : {}
            }
          >
            Why it Matters?
          </HashLink>
          <HashLink
            to="#luck"
            onClick={handleClick4}
            class="nav-link"
            style={
              isActive("#luck")
                ? {
                    color: "#B078FF",
                    backgroundColor: "#271B39",
                  }
                : {}
            }
          >
            $LUCK
          </HashLink>
          <HashLink
            to="#usecases"
            onClick={handleClick5}
            class="nav-link"
            style={
              isActive("#usecases")
                ? {
                    color: "#B078FF",
                    backgroundColor: "#271B39",
                  }
                : {}
            }
          >
            Use Cases
          </HashLink>
          <div className="mainbtn">
            <a href="/lightpaper.pdf" target="_blank" className="greybtn">read LIGHTPAPER</a>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default Header;
